/* eslint no-param-reassign: "error" */

export default {
  SET_ALL_CONTRACT_AGGREGATES(state, data) {
    state.contractAggregates = data;
  },

  ADD_CONTRACT_AGGREGATE(state, data) {
    state.contractAggregates.push(data);
  },

  SET_CURRENT_CONTRACT(state, data) {
    state.currentContract = data;
    state.addedLessorsIds = state.currentContract.contract.lessorCounterpartyIds;
  },

  EDIT_VALUE(state, formField) {
    if (formField.index === undefined) {
      state.currentContract[formField.parent][formField.name] = formField.value;
    } else {
      state.currentContract[formField.parent][formField.index][formField.name] = formField.value;
    }
    hideCharts(state);
  },

  UPDATE_LESSOR(state, data) {
    state.addedLessorsIds[data.index] = +data.value;
    hideCharts(state);
  },

  DELETE_LESSOR(state, data) {
    state.addedLessorsIds.splice(data.index, 1);
  },

  ADD_LESSOR(state) {
    state.addedLessorsIds.push('');
    hideCharts(state);
  },

  ADD_RENAME_LESSOR_LIST(state, data) {
    state.renameLessorList.push(data);
  },

  CLEAR_RENAME_LESSOR_LIST(state) {
    state.renameLessorList = [];
  },

  UPDATE_ASSET_COMPONENTS(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex][data.name] = data.value;
    hideCharts(state);
  },

  REMOVE_ASSET_COMPONENTS(state, assetIndex) {
    state.currentContract.assets[assetIndex].assetComponents.length = 1;
    hideCharts(state);
  },

  ADD_ASSET(state, data) {
    state.currentContract.assets.push(data);
    hideCharts(state);
  },

  ADD_ASSET_COMPONENT(state, data) {
    state.currentContract.assetComponents.push(data);
    hideCharts(state);
  },

  ADD_TERMINATION_OPTION(state, terminationInfo) {
    state.currentContract.assets[terminationInfo.assetIndex].assetComponents[terminationInfo.assetComponentIndex]
      .termination = terminationInfo.data;
    hideCharts(state);
  },

  UPDATE_TERMINATION_OPTION(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex]
      .termination[data.name] = data.value;
    hideCharts(state);
  },

  ADD_EXTENSION_OPTION(state, extensionInfo) {
    state.currentContract.assets[extensionInfo.assetIndex].assetComponents[extensionInfo.assetComponentIndex]
      .extension = extensionInfo.data;
    hideCharts(state);
  },

  UPDATE_EXTENSION_OPTION(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex]
      .extension[data.name] = data.value;
    hideCharts(state);
  },

  ADD_BUYOUT_OPTION(state, buyoutInfo) {
    state.currentContract.assets[buyoutInfo.assetIndex].assetComponents[buyoutInfo.assetComponentIndex]
      .buyout = buyoutInfo.data;
    hideCharts(state);
  },

  UPDATE_BUYOUT_OPTION(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex]
      .buyout[data.name] = data.value;
    hideCharts(state);
  },

  SET_UNIT_OF_MEASURE(state, data) {
    state.unitOfMeasure = data;
    hideCharts(state);
  },

  ADD_NEW_PAYMENT(state, paymentInfo) {
    state.currentContract.assets[paymentInfo.assetIndex].assetComponents[paymentInfo.assetComponentIndex]
      .paymentsParameters.push(paymentInfo.payment);
    hideCharts(state);
  },

  UPDATE_PAYMENT(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex].paymentsParameters[data
      .paymentsParametersIndex][data.name] = data.value;
    hideCharts(state);
  },

  UPDATE_PAYMENT_CURRENCY_RATE_PARAMS(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex].paymentsParameters[data
      .paymentsParametersIndex].currencyRateParameters[data.name] = data.value;
    hideCharts(state);
  },

  UPDATE_PAYMENT_INDEXATION(state, data) {
    state.currentContract.assets[data.assetIndex].assetComponents[data.assetComponentIndex].paymentsParameters[data
      .paymentsParametersIndex].indexation[data.name] = data.value;
    hideCharts(state);
  },

  SET_VIEW_STATE_OF_CHARTS(state, value) {
    state.isHideCharts = value;
  },

  SET_CONTRACT_RAW_EDITING_STATE(state, value) {
    state.isContractRawEditing = value;
  },
  SET_CONTRACT_IN_CLOSED_PERIOD_STATE(state, value) {
    state.isInClosedPeriod = value;
  },

  SET_CONTRACT_RAW_EDITING_SIMPLIFIED_STATE(state, value) {
    state.isContractSimplifiedEditing = value;
  },

  SET_CONTRACT_CHANGE_CONDITION_STATE(state, value) {
    state.isContractChangeCondition = value;
  },

  SET_CONTRACT_EVENT_EDITING_STATE(state, value) {
    state.isContractEventEditing = value;
  },
};

function hideCharts(state) {
  state.isHideCharts = true;
}
